import React from 'react';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaSnapchat,
  FaPinterest,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

import Button from '../components/Button';
import { showLoginModal, showRegisterModal } from '../actions/ui';
import LoginModal from '../components/LoginModal';
import RegisterModal from '../components/RegisterModal';
import { ReactComponent as TikTokIcon } from '../assets/tik-tok.svg';
import { RootState } from '../config/store';
import { track } from '../services/mixpanelService';
import ContinueRegisterModal from '../components/ContinueRegisterModal';

export interface LandingProps { }

const Landing: React.FC<LandingProps> = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );

  track("load")

  return (
    <>
      <LoginModal />
      <RegisterModal />
      <ContinueRegisterModal />
      <Helmet>
        <title>
          twigBIG | Social e-commerce marketplace in Beauty and fashion that's
          empowered by AI,AR and VR
        </title>
      </Helmet>
      <header>
        <div className="hd-top-outer clearfix">
          <div className="container">
            <div className="hd-top d-flex">
              <div className="logo mr-auto">
                <a href="#">
                  <img width="137px"
                    alt="twigbig"
                    src={`${process.env.PUBLIC_URL}/assets/img/twigLogoWhite.svg`} />
                </a>
              </div>
              {!isAuthenticated ? (
                <div className="navigation ml-auto">
                  <Button
                    onClick={() => dispatch(showLoginModal())}
                    color="primary"
                  >
                    Login
                  </Button>
                  <Button
                    onClick={() => dispatch(showRegisterModal())}
                    className="ml-4"
                    color="primary"
                  >
                    Register
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="video">
          <div className="overlay" />
          <div className="sd-con-inner">
            <h3 style={{ padding: '0 30px' }}>
              Social eCommerce marketplace in beauty and fashion
            </h3>
            <p style={{ padding: '15px 30px' }} className="word-rap">
              Shoppable-stories eCommerce marketplace that's empowered by AI to
              detect users' emotional-context and use AR/VR to provide immersive
              shopping experiences
            </p>
            <Link to="/register" className="find-btn">
              REGISTER AS A SELLER (FOR CONTENT CREATORS & BUSINESSES)
            </Link>
          </div>
        </div>
      </header>

      <section className="head-bottom">
        <div className="container">
          <div className="brand-logo">
            <p>
              No more loss on cheap products and services, find the best.
              Download Now
            </p>
            <br />
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://itunes.apple.com/us/app/twigbig/id1222335980?ls=1&mt=8"
              >
                <img alt="itunes apple" src="img/apple.png" />
              </a>
            </span>
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.twigbig.app"
              >
                <img alt="play google" src="img/google-play.png" />
              </a>
            </span>
          </div>
        </div>
      </section>

      <section className="border-f">
        <div className="container">
          <div className="feature">
            <h1>OUR UNIQUE FEATURES</h1>
            <p>
              The more you use it the more accurate the recomendations will be.
            </p>

            <div className="row">
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="Personalized Recommendations" src="img/icon-6.png" />
                  <h3>Personalized Recommendations</h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="Recommend and Earn CASH MONEY" src="img/icon-1.png" />
                  <h3>Recommend and Earn CASH MONEY</h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="Shop in Virtual / Augmented Reality" src="img/icon-5.png" />
                  <h3>Shop in Virtual / Augmented Reality</h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="Create Your AI-Smart E-Shop" src="img/icon-2.png" />
                  <h3>Create Your AI-Smart E-Shop</h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="FREE promotion by influencers" src="img/icon-3.png" />
                  <h3>FREE promotion by influencers</h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="feat-1">
                  <img alt="40% better sales and conversions" src="img/icon-4.png" />
                  <h3>40% better sales and conversions</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="ft-bg">
        <div className="container">
          <div className="row ft-padding clearfix">
            <div className="col-sm-3">
              <div className="footer-left">
                <a href="#">
                  <img
                    width="137px"
                    alt="twigbig"
                    src={`${process.env.PUBLIC_URL}/assets/img/twigLogoWhite.svg`}
                  />
                </a>
                <ul>
                  <li>
                    <Link to="contact-us">Contact Us</Link>
                  </li>
                  <li style={{ marginBottom: '5px' }}>
                    <a style={{ fontSize: '11px' }}>WE ACCEPT</a>
                  </li>
                  <li style={{ marginBottom: '0' }}>
                    <img
                      alt="twigbig"
                      style={{
                        width: '76px',
                        height: '44px',
                        marginRight: '5px',
                        borderRadius: '8%',
                        backgroundColor: "white",
                        objectFit: "contain"
                      }}
                      src="images/MasterCard.jpg"
                    />
                    <img
                      style={{
                        width: '76px',
                        height: '44px',
                        borderRadius: '8%',
                        backgroundColor: "white",
                        objectFit: "contain"
                      }}
                      src="images/visa.PNG"
                      alt="twigbig"
                    />
                  </li>
                  <li style={{ marginBottom: '5px' }}>
                    <a style={{ fontSize: '11px' }}>Powered by Stripe</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="footer-middle">
                <h5>FOLLOW US</h5>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/twigbig/">
                      <FaFacebook />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/twigBIGTweets">
                      <FaTwitter />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/twigbig/">
                      <FaInstagram />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.snapchat.com/add/twigbigsnap">
                      <FaSnapchat />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.pinterest.com/twigbig/">
                      <FaPinterest />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.tiktok.com/@twigbig">
                      <TikTokIcon />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="footer-middle footer-right pull-right">
                <h5>DOWNLOAD THE APP</h5>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://itunes.apple.com/us/app/twigbig/id1222335980?ls=1&mt=8"
                    >
                      <img alt="itunes.apple" src="img/ft-1.png" />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://play.google.com/store/apps/details?id=com.twigbig.app"
                    >
                      <img alt="play.google" src="img/ft-2.png" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="copyrights clearfix">
            <div className="copy-right pull-right">
              <ul style={{ width: '300px', marginBottom: '20px' }}>
                <li style={{ width: '100%' }}>
                  <Link to="terms-and-conditions">
                    Terms & Conditions{' '}
                  </Link>
                </li>
                <li style={{ width: '100%' }}>
                  <Link to="privacy-policy">
                    Privacy Policy
                  </Link>
                </li>
                <li style={{ width: '100%' }}>
                  <Link to="refund-and-cancellation-policy">
                    Refund and Cancellation policy
                  </Link>
                </li>
                <li style={{ width: '100%' }}>
                  <Link to="shipping-and-return-policy">
                    Shipping and Return Policy
                  </Link>
                </li>

                <li style={{ width: '100%' }}>
                  <Link to="about-us">
                    About Us
                  </Link>
                </li>
                <li style={{ width: '100%', display: "none" }}>
                  <Link to="discover">
                    Discover
                  </Link>
                </li>

              </ul>
            </div>
          </div>
          <div className="copy-left pull-left">
            <h5> © 2021 twigBIG, Inc. All Rights Reserved.</h5>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Landing;
